import React, { useMemo } from 'react';
import { AdminSidebarComponentProps } from '../../JsonComponent.types';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { Schedule } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useEventLocation } from '@shared/utils/eventLocation';
import { useFormattedDate } from '@shared/hooks/useFormattedDate';
import { EventDetailsData } from '../EventDetails.types';

export const EventDetailsGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('eventDetailsCustomComponent');
  const { eventInfo } = useEventInfo();

  const date = eventInfo?.finalizedDate;
  const location = eventInfo?.locationInfo?.name;
  const content: EventDetailsData = props.componentData?.containerContent?.content || {};

  const { eventLocationDisplayName } = useEventLocation(location, content.locationFormat);

  const dateFormat = content.dateFormat ?? 'MMMM do, yyyy';
  const eventDateHeader = useFormattedDate(date?.milliseconds ? new Date(date.milliseconds) : undefined, dateFormat, {
    titlecase: true,
    timezone: date?.timezone,
  });

  const subTitle = useMemo(() => {
    if (eventDateHeader && eventLocationDisplayName) {
      return `${eventDateHeader} • ${eventLocationDisplayName}`;
    }
    return eventDateHeader || eventLocationDisplayName || '';
  }, [eventDateHeader, eventLocationDisplayName]);

  return (
    <SimpleGrabHandle
      title={tq`Event Details`}
      subTitle={subTitle}
      icon={<Schedule size={32} />}
      {...props}
    />
  );
};
